import {
	requests
}from '../../../api/agent'

export default {
	GetOwnTasks    : (params) => requests.post('/Task/getOwnTasks', params),
	GetOwnOrgTasks : (params) => requests.post('/Task/getOwnOrgTasks', params),
	GetSubOrgTasks : (params) => requests.post('/Task/getSubOrgTasks', params),
	GetAllStatuses : () => requests.get('/ReTaskStatus/getAll', {}),
	GetAllTypes    : () => requests.get('/ReTaskType/getAll', {}),
	GetAllControls : () => requests.get('/ReControlType/getAll', {}),
	exportToExcel  : (params) => requests.postFile('/Task/exportToExcel', params),
	DeleteTask 	   : (params) => requests.post('/Task/delete', params)
}